import ProficiencyTagRanking from './ProficiencyTagRanking';
export default ProficiencyTagRanking;